import { Typography } from '@material-ui/core'
import React from 'react'

import { UserBrief } from '../../types/users'
import { UserRowMenu } from './UserRowMenu'
import useStyles from './styles/UsersTable.styles'

interface UserRowProps {
  data: UserBrief
}

const UserRowMobile: React.FC<UserRowProps> = ({ data }) => {
  const { ID, name, email, role } = data
  const classes = useStyles()

  return (
    <>
      <div className={classes.tableRowMobile} key={ID}>
        <div className={classes.nameCell}>
          {/* <div className={classes.userLogo}>{RolesShortcuts[role!]}</div> */}
          <div className={classes.userLogo}>{role}</div>
          <div>
            <Typography variant="h4">{name}</Typography>
            <Typography variant="body1">{email}</Typography>
          </div>
        </div>
        <UserRowMenu data={data} />
      </div>
    </>
  )
}

export default UserRowMobile
